import { defineMessages } from 'react-intl';

export default defineMessages({
  pending: { defaultMessage: 'Transaction(s) Pending' },
  confirmed: { defaultMessage: 'Success!' },
  failed: { defaultMessage: 'Transaction(s) Failed' },
  dashboard: { defaultMessage: 'Dashboard' },
});
